import { Box, Card, CardContent, Typography } from '@mui/material';
import React from 'react';
import { injectPropsToChildren } from 'utils/injectPropsToChildren';

export interface SettingsSectionProps extends React.PropsWithChildren<{}> {
  title?: string;
  description?: string;
  disabled?: boolean;
}

export function SettingsSection({
  title,
  description,
  disabled = false,
  ...rest
}: SettingsSectionProps) {
  const children = injectPropsToChildren<{ disabled?: boolean }>(rest.children, { disabled });

  return (
    <>
      <Card sx={{ overflow: 'visible' }}>
        <CardContent>
          {title && (
            <Typography gutterBottom={!description} variant="h2">
              {title}
            </Typography>
          )}
          {description && (
            <Box sx={{ lineHeight: 1, mb: 3 }}>
              <Typography variant="caption" color="textSecondary">
                {description}
              </Typography>
            </Box>
          )}
          {children}
        </CardContent>
      </Card>
    </>
  );
}
